export enum BookingStatus {
  WAITING = "WAITING",
  MAIN = "MAIN",
}

export enum CapacityEnum {
  FROM_1_TO_25 = "FROM_1_TO_25",
  FROM_25_TO_120 = "FROM_25_TO_120",
  FROM_120_TO_250 = "FROM_120_TO_250",
  FROM_250_TO_500 = "FROM_250_TO_500",
}

export enum EventTypeEnum {
  NORMAL = "NORMAL",
  FOOD = "FOOD",
}
